import { connect } from "react-redux";
import { DetailsSubHeader } from "components/sectionHeader";
import { type RootState } from "features/Application/globaltypes/redux";
import { type Props as DetailsSubHeaderProps } from "components/sectionHeader/sectionSubHeader/SectionSubHeader";
import { campaignsStateSelector } from "../state/selectors";

const mapStateToProps = (state: RootState, ownProps: DetailsSubHeaderProps & { showLastModified: boolean }) => {
  const base = campaignsStateSelector(state).base;
  return {
    isUpdateInProgress: base.entityState.isEntityCommandInProgress && ownProps.isUpdateInProgress,
    lastModifiedDateTime: ownProps.showLastModified
      ? base.entityState.lastModifiedDateTime ?? ownProps.lastModifiedDateTime
      : undefined,
  };
};

export default connect(mapStateToProps)(DetailsSubHeader);
